import C from '../pages/common/constantes'
import auth from '../services/auth'
import {cents} from '../filters/number'

function recargaValida(val, args){
  let mult = parseInt(args[0]);
  let min = parseInt(args[1]);
  if(!val)
    return false;

  val = parseInt(val.toString().replace(/[^0-9]/g, ''));

  if(val > min)
    return true;

  if(val / mult > 0 && val % mult == 0)
    return true;

  return false;
}


export default {
  messages: {
    en: (field, args) => {
      let mult = args[0];
      return `Valor de recarga inválido`;
    },
    'pt-BR': (field, args) => {
      let mult = args[0];
      return `Valor de recarga inválido`;
    }
  },
  validate(value, args) {
    return recargaValida(value, args);
  }
};




// WEBPACK FOOTER //
// ./src/validators/valor-recarga-valido-open.js